import React, {useEffect, useState, useRef} from 'react';
import {useHistory, useLocation} from 'react-router-dom'
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import "overlayscrollbars/css/OverlayScrollbars.css";
import CustomSelect from "./CustomSelect";
import device from 'current-device'

const options = {
    type: {
        'all': {value: '', label: 'Type:All'},
        'slot': {value: 'slot', label: 'Type:Slot'},
        'table': {value: 'table', label: 'Type:Table'},
    },
    bonus: {
        'all': {value: '', label: 'Bonus Game:All'},
        '1': {value: '1', label: 'Bonus Game:Yes'},
        '0': {value: '0', label: 'Bonus Game:No'},
    },
    free: {
        'all': {value: '', label: 'Free games:All'},
        '1': {value: '1', label: 'Free games:Yes'},
        '0': {value: '0', label: 'Free games:No'},
    },
    reels: {
        'all': {value: '', label: 'Reels:All'},
        '0': {value: '0', label: 'Reels:No'},
        '3': {value: '3', label: 'Reels:3'},
        '4': {value: '4', label: 'Reels:4'},
        '5': {value: '5', label: 'Reels:5'},
        '6': {value: '6', label: 'Reels:6'},
    }
};

const Filter = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const {search} = useLocation();
    const refFilter = useRef(null);


    const [type, setType] = useState(null);
    const [bonus, setBonus] = useState(null);
    const [free, setFree] = useState(null);
    const [reels, setReels] = useState(null);
    const [name, setName] = useState('');

    const submitForm = () => {
        if (history.location.search !== `?type=${type.value}&bonus=${bonus.value}&free=${free.value}&reels=${reels.value}&name=${name}`) {
            history.replace({
                search: `?type=${type.value}&bonus=${bonus.value}&free=${free.value}&reels=${reels.value}&name=${name}`
            });
        }
        if (device.desktop()) {
            window.scrollTo(0, refFilter.current.offsetTop - document.querySelector('header.header').offsetHeight);
        }
    };

    const clearForm = () => {
        if (history.location.search) {
            history.replace({
                search: ''
            });
        }
        if (device.desktop()) {
            window.scrollTo(0, refFilter.current.offsetTop - document.querySelector('header.header').offsetHeight);
        }
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(search);

        if (Array.from(searchParams).length > 0) {
            searchParams.forEach((value, key) => {
                switch (key) {
                    case 'type':
                        setType(options.type[value === '' ? 'all' : value]);
                        break;
                    case 'bonus':
                        setBonus(options.bonus[value === '' ? 'all' : value]);
                        break;
                    case 'free':
                        setFree(options.free[value === '' ? 'all' : value]);
                        break;
                    case 'reels':
                        setReels(options.reels[value === '' ? 'all' : value]);
                        break;
                    case 'name':
                        setName(value);
                        break;
                    default:
                        break;
                }
            })
        } else {
            setType(options.type.all);
            setBonus(options.bonus.all);
            setFree(options.free.all);
            setReels(options.reels.all);
            setName('');
        }
    }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const searchParams = new URLSearchParams(search);
        if (Array.from(searchParams).length > 0 && refFilter) {
            window.scrollTo(0, refFilter.current.offsetTop - document.querySelector('header.header').offsetHeight);
        }
    }, [search, refFilter]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="filter_catalog" ref={refFilter}>
            <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                {type && <CustomSelect
                    game={type}
                    setGame={setType}
                    options={options.type}
                />}
                {bonus && <CustomSelect
                    game={bonus}
                    setGame={setBonus}
                    options={options.bonus}
                />}
                {free && <CustomSelect
                    game={free}
                    setGame={setFree}
                    options={options.free}
                />}
                {reels && <CustomSelect
                    game={reels}
                    setGame={setReels}
                    options={options.reels}
                />}
                <input
                    className="search_input"
                    name="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder={t('Search by game name')}
                />
                <button
                    type='button'
                    className={`reset ${Array.from(new URLSearchParams(search)).length > 0 ? 'active' : ''}`}
                    onClick={clearForm}
                >{t('RESET FILTER')}</button>
                <button
                    type='button'
                    className="apply"
                    onClick={submitForm}
                >{t('APPLY FILTER')}</button>
            </form>
        </div>
    );
};

export default observer(Filter);